import { useState, useRef } from 'react';
import {  Outlet, useLocation, useNavigate } from 'react-router-dom';

// material
import { styled, createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';


import {
  Box,
  Collapse,
  Grid,
  Button,
} from '@mui/material';

import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';


import { MHidden } from '../../components/@material-extend';


import AlertDialog from '../../components/AlertDialog';
import Notifications from '../../components/_dashboard/soundbox/SoundboxNotifications';


import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';



// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 78;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'

});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE,
  // paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP,
    // paddingLeft: theme.spacing(1),
    // paddingRight: theme.spacing(1)
  }
}));


const useStyles = makeStyles({
  locationHistoryTitle: {
    fontSize: 14,
    fontWeight: "bold"
  },

  locationHistoryAddress: {
    fontSize: 12,

  },

  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 1, // Number of lines to show before truncating
    '-webkit-box-orient': 'vertical',
  },

  cardWithBorder: {
    background: "#FFFFFF",
    border: " 1px solid #B0B9C7",
    boxShadow: "0px 10px 19px 1px #EAEAFF",
    boxSizing: "border-box",
    borderRadius: "20px",
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '75vh',
    marginTop: "9%",
    // marginRight: "5px",
    width: "300px",
    minWidth: "300px",
    maxWidth: "300px",
    height: "100%",

  },
})

// ----------------------------------------------------------------------




export default function DashboardLayout() {

  const location = useLocation()

  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",
  });

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,    
        sm: 768,  
        md: 1024, 
        lg: 1280, 
        xl: 390,  
      },
    },
  });


  const [open, setOpen] = useState(false);

  const boxRef = useRef(null);
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);

  const toggleNotifications = () => {
    setIsNotificationsOpen((prev) => !prev);
  };





  return (
    <RootStyle>
      <DashboardNavbar onOpenSidebar={() => setOpen(true)}/>
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <MainStyle>
        <Outlet />
      </MainStyle>

    {location?.pathname !== '/dashboard/soundboxdevicedetails' ? (
        <MHidden width="lgDown">
          <Box sx={{ position: 'relative', right: 18, top: 100, width: 310, pl: 1, height: '80vh' }}>
            <Notifications />
          </Box>
        </MHidden>
      ) 
      :
      null
    }

      <AlertDialog
        openAlertDialog={openAlertDialog}
        message={alertDialogMetas?.message}
        title={alertDialogMetas?.title}
        btnLabel={alertDialogMetas?.btnLabel}
        handleClose={() => setOpenAlertDialog(false)}
      />
    </RootStyle>
  );
}